/**
 * Custom Mega Menu Logic
 * Handles mobile toggles and accessibility
 */
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('CustomMobileDrawer');
  const trigger = document.getElementById('MobileMenuTrigger');
  const closeBtn = document.getElementById('MobileMenuClose');
  const overlay = document.getElementById('CustomMobileDrawerOverlay');
  const backBtn = document.getElementById('MobileMenuBack');
  const drawerTitle = document.getElementById('MobileMenuTitle');
  const panesWrapper = drawer?.querySelector('.custom-mobile-drawer__panes-wrapper');

  const toggleDrawer = (isOpen) => {
    const wasOpen = drawer?.classList.contains('is-open');
    if (wasOpen === isOpen) return;

    drawer?.classList.toggle('is-open', isOpen);
    trigger?.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('mobile-menu-open', isOpen);

    if (isOpen) {
      if (typeof window.trapFocus === 'function') window.trapFocus(drawer);
      return;
    }

    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(trigger);
    panesWrapper?.classList.remove('has-sub-pane-open');
    document.querySelectorAll('.custom-mega-menu__item').forEach(i => i.classList.remove('is-open'));
    document.querySelectorAll('.custom-mega-menu__link[aria-expanded]').forEach(l => l.setAttribute('aria-expanded', 'false'));
    backBtn?.classList.add('visibility-hidden');
    if (drawerTitle) drawerTitle.textContent = '';
  };

  if (trigger) trigger.addEventListener('click', () => toggleDrawer(true));
  if (closeBtn) closeBtn.addEventListener('click', () => toggleDrawer(false));
  if (overlay) overlay.addEventListener('click', () => toggleDrawer(false));

  if (backBtn) {
    backBtn.addEventListener('click', () => {
      const openItem = document.querySelector('.custom-mega-menu__item.is-open');
      if (openItem && panesWrapper) {
        panesWrapper.classList.remove('has-sub-pane-open');
        backBtn.classList.add('visibility-hidden');
        const triggerLink = openItem.querySelector('.custom-mega-menu__link');
        triggerLink?.setAttribute('aria-expanded', 'false');

        if (drawerTitle) drawerTitle.textContent = '';
        panesWrapper.addEventListener('transitionend', () => {
          if (!panesWrapper.classList.contains('has-sub-pane-open')) {
            openItem.classList.remove('is-open');
            triggerLink?.focus();
          }
        }, { once: true });
      }
    });
  }

  const megaMenuItems = document.querySelectorAll('.custom-mega-menu__item.has-dropdown');

  megaMenuItems.forEach(item => {
    const link = item.querySelector('.custom-mega-menu__link');

    link.addEventListener('click', (event) => {
      if (window.innerWidth < 990 && item.classList.contains('has-dropdown')) {
        event.preventDefault();
        event.stopPropagation();
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
        if (drawerTitle) {
          drawerTitle.textContent = link.querySelector('span').textContent;
        }
        backBtn?.classList.remove('visibility-hidden');
        // Small delay to ensure is-open visibility is applied before the slide starts
        requestAnimationFrame(() => {
          panesWrapper?.classList.add('has-sub-pane-open');
        });
      }
    });

  });

  // Handle Escape Key Global
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (panesWrapper?.classList.contains('has-sub-pane-open')) {
        backBtn?.click();
      } else if (drawer?.classList.contains('is-open')) {
        toggleDrawer(false);
      }
    }
  });
});